import type { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';
import { TPO_DELETE_REPORT_MODAL } from '../../../config/testIds';

const antIconDanger = <LoadingOutlined style={{ fontSize: 16, color: 'red' }} spin />;

const DELETE_BUTTON_PROPS = { type: 'primary', danger: true, style: { borderRadius: 6 } } as const;

export interface DeleteReportModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    reportName: string;
    isPending: boolean;
}

const DeleteReportModal: FC<DeleteReportModalProps> = ({ open, onClose, onConfirm, reportName, isPending }) => {
    const { labels } = useTpoGenConfig();
    const modalLabels = labels.comparisonReport.deleteReportModal;

    return (
        <ConfirmationModal
            open={open}
            onCancel={onClose}
            onSubmitClick={onConfirm}
            okText={isPending ? <Spin indicator={antIconDanger} /> : labels.common.delete}
            cancelText={labels.common.cancel}
            okButtonProps={DELETE_BUTTON_PROPS}
            loading={isPending}
            closable
            maskClosable={false}
            title={modalLabels.title(reportName || modalLabels.unnamedReport)}
            description={
                <div className="bg-[#fafafa] rounded-lg p-2">
                    <p className="text-sm text-[#18181b]">{modalLabels.description}</p>
                </div>
            }
            width={520}
            data-testid={TPO_DELETE_REPORT_MODAL}
        />
    );
};

DeleteReportModal.displayName = 'DeleteReportModal';
export default DeleteReportModal;
